module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Cowbell-d015105cb04895f5da057e1d1827e0a7.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Cowbell.mp3
// module id = 48
// module chunks = 0